import { Outlet } from 'react-router-dom';

export default function Projects() {
  return <Outlet />;
}
